import { getSrc } from 'gatsby-plugin-image';
import { isGatsbyImage } from '../../utils/gatsby';
/**
 *
 * @param {ImagePropType} image
 * @returns a URL for the image
 */

export function getImageSrc(image) {
  if (typeof image === 'string') {
    return image;
  }

  if (isGatsbyImage(image)) {
    return getSrc(image);
  }

  return null;
}
/**
 *
 * @param {ImagePropType} image
 * @returns a unique id of the image, to be used as key in JSX for-loops
 */

export function getImageKey(image) {
  return getImageSrc(image);
}